import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { NavLink } from "react-router-dom";
import axios from "axios";

function Career() {

    // ---------------- STATE ----------------
    const [formData, setFormData] = useState({
        name: "",
        admissionClass: "",
        contact: "",
        email: "",
        message: "",
        attachments: null
    });

    const [formErrors, setFormErrors] = useState({});
    const [submitStatus, setSubmitStatus] = useState("idle");
    const [message, setMessage] = useState("");

    // ---------------- HANDLERS ----------------
    const handleChange = (e) => {
        const { name, value, files } = e.target;

        if (name === "contact") {
            const cleaned = value.replace(/\D/g, "").slice(0, 10);
            return setFormData((prev) => ({ ...prev, contact: cleaned }));
        }

        if (name === "attachments") {
            return setFormData((prev) => ({ ...prev, attachments: files[0] }));
        }

        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    // ---------------- VALIDATION ----------------
    const validateForm = () => {
        const errors = {};
        const phonePattern = /^[0-9]{10}$/;
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!formData.name.trim()) errors.name = "Name is required";
        if (!formData.admissionClass.trim()) errors.admissionClass = "City is required";

        if (!formData.contact.trim()) {
            errors.contact = "Phone number is required";
        } else if (!phonePattern.test(formData.contact)) {
            errors.contact = "Phone must be 10 digits";
        }

        if (formData.email && !emailPattern.test(formData.email)) {
            errors.email = "Invalid email format";
        }

        if (!formData.message.trim()) errors.message = "Message is required";

        // ✅ FILE VALIDATION (PDF + DOC + IMAGE)
        if (formData.attachments) {
            const allowedTypes = [
                "application/pdf",
                "application/msword",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                "image/jpeg",
                "image/png",
                "image/jpg"
            ];

            if (!allowedTypes.includes(formData.attachments.type)) {
                errors.file = "Only PDF, DOC or Image files allowed";
            }

            if (formData.attachments.size > 2 * 1024 * 1024) {
                errors.file = "File must be less than 2MB";
            }
        }

        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    // ---------------- SUBMIT ----------------
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        setSubmitStatus("submitting");
        setMessage("");

        try {
            const API_URL = "https://webapi.entab.info/api/form/SMNSB/career";

            const formPayload = new FormData();

            formPayload.append("type", "career");
            formPayload.append("name", formData.name);
            formPayload.append("location", formData.admissionClass);
            formPayload.append("phone", formData.contact);
            formPayload.append("email", formData.email);
            formPayload.append("message", formData.message);

            if (formData.attachments) {
                formPayload.append("attachments", formData.attachments);
            }

            const response = await axios.post(API_URL, formPayload, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            });

            if (response.status === 200) {
                setMessage("✅ Form submitted successfully!");
                setSubmitStatus("submitted");

                setFormData({
                    name: "",
                    admissionClass: "",
                    contact: "",
                    email: "",
                    message: "",
                    attachments: null
                });

                document.getElementById("form1").reset();

                setTimeout(() => setSubmitStatus("idle"), 3000);
            }

        } catch (error) {
            console.error(error);
            setMessage("❌ Something went wrong. Try again.");
            setSubmitStatus("idle");
        }
    };

    // ---------------- UI ----------------
    return (
        <>
            <Header />

            <section className="inr-header">
                <div className="container">
                    <div className="inr-header-content">
                        <h1 className="title">Career</h1>
                        <ul className="breadcrumb">
                            <li><NavLink to="/">Home</NavLink></li>
                            <li>Career</li>
                        </ul>
                    </div>
                </div>
            </section>

            <section className="innerBody contact career">
                <div className="container them-container">

                    <form id="form1" onSubmit={handleSubmit}>
                        <div className="row">

                            {/* LEFT */}
                            <div className="col-lg-6">
                                <input
                                    name="name"
                                    placeholder="Name"
                                    className="form-control mb-2"
                                    value={formData.name}
                                    onChange={handleChange}
                                />
                                {formErrors.name && <p className="text-danger">{formErrors.name}</p>}

                                <input
                                    name="email"
                                    placeholder="Email"
                                    className="form-control mb-2"
                                    value={formData.email}
                                    onChange={handleChange}
                                />
                                {formErrors.email && <p className="text-danger">{formErrors.email}</p>}

                                <input
                                    name="contact"
                                    placeholder="Phone"
                                    className="form-control mb-2"
                                    value={formData.contact}
                                    onChange={handleChange}
                                />
                                {formErrors.contact && <p className="text-danger">{formErrors.contact}</p>}

                                <input
                                    name="admissionClass"
                                    placeholder="City"
                                    className="form-control mb-2"
                                    value={formData.admissionClass}
                                    onChange={handleChange}
                                />
                                {formErrors.admissionClass && <p className="text-danger">{formErrors.admissionClass}</p>}
                            </div>

                            {/* RIGHT */}
                            <div className="col-lg-6">
                                <input
                                    type="file"
                                    name="attachments"
                                    className="form-control mb-2"
                                    onChange={handleChange}
                                    accept=".pdf,.doc,.docx,image/*"
                                />

                                <small className="text-muted">
                                    Upload Resume (PDF, DOC, or Image)
                                </small>

                                {formData.attachments && (
                                    <>
                                        <p className="text-success mt-2">
                                            {formData.attachments.name}
                                        </p>

                                        {/* IMAGE PREVIEW */}
                                        {formData.attachments.type.startsWith("image/") && (
                                            <img
                                                src={URL.createObjectURL(formData.attachments)}
                                                alt="preview"
                                                style={{ width: "120px", marginTop: "10px" }}
                                            />
                                        )}
                                    </>
                                )}

                                {formErrors.file && <p className="text-danger">{formErrors.file}</p>}

                                <textarea
                                    name="message"
                                    className="form-control mt-2"
                                    placeholder="Message"
                                    value={formData.message}
                                    onChange={handleChange}
                                />
                                {formErrors.message && <p className="text-danger">{formErrors.message}</p>}
                            </div>

                            {/* SUBMIT */}
                            <div className="col-12 mt-3">
                                <button
                                    className="btn btn-warning"
                                    disabled={submitStatus === "submitting"}
                                >
                                    {submitStatus === "submitting" ? "Submitting..." : "Submit"}
                                </button>

                                {message && <p className="mt-2">{message}</p>}
                            </div>

                        </div>
                    </form>

                </div>
            </section>

            <Footer />
        </>
    );
}

export default Career;
